export default "__VITE_ASSET__CacWD9g5__"